export { default } from './SubTitle'
